import { FormEnums } from "models/enums";
import { HoldingRegisterFormTypes } from "models/formTypes";
import { HoldingRegisterAssetsFilter } from "models/formTypes/holdingRegister";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
import { QueryStateHelper } from "utils/helpers";

function useHoldingRegisterCommonFilterProps() {
  const generalFilterFormFields = {
    description: {
      label: TranslationKeys.Common.Description,
      type: FormEnums.FormFieldType.TEXT,
    },
    isDeleted: {
      label: TranslationKeys.HoldingRegister.Removed,
      type: FormEnums.FormFieldType.BOOLEANSELECTION,
    },
    depreciates: {
      label: TranslationKeys.HoldingRegister.Depreciation,
      type: FormEnums.FormFieldType.BOOLEANSELECTION,
    },
    isActive: {
      label: TranslationKeys.Common.Active,
      type: FormEnums.FormFieldType.BOOLEANSELECTION,
    },
    hasVouchers: {
      label: TranslationKeys.HoldingRegister.HaveVerification,
      type: FormEnums.FormFieldType.BOOLEANSELECTION,
    },
    serialNumber: {
      label: TranslationKeys.Common.Number,
      type: FormEnums.FormFieldType.NUMBERRANGE,
    },
  };

  const dateFilterFormFields = {
    snapshot: {
      label: TranslationKeys.Common.Snapshot,
      type: FormEnums.FormFieldType.DATE,
    },
    startMonth: {
      label: TranslationKeys.HoldingRegister.AcquisitionDate,
      type: FormEnums.FormFieldType.DATERANGE,
    },
    terminationMonth: {
      label: TranslationKeys.HoldingRegister.Expires,
      type: FormEnums.FormFieldType.DATERANGE,
    },
  };

  const filterQueryStateHandler: FilterQueryStateHandler<HoldingRegisterFormTypes.HoldingRegisterAssetsBaseFilter> = {
    description: QueryStateHelper.stringQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.Description
    ),
    isDeleted: QueryStateHelper.booleanQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.IsDeleted
    ),
    depreciates: QueryStateHelper.booleanQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.Depreciates
    ),
    isActive: QueryStateHelper.booleanQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.IsActive
    ),
    snapshot: QueryStateHelper.dateQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.Snapshot
    ),
    startMonth: QueryStateHelper.dateRangeQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.StartMonth
    ),
    terminationMonth: QueryStateHelper.dateRangeQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.TerminationMonth
    ),
    hasVouchers: QueryStateHelper.booleanQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.HasVouchers
    ),
    serialNumber: QueryStateHelper.numberRangeQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterAssetsBaseFilter.SerialNumber
    ),
  };

  const initialFilter: HoldingRegisterAssetsFilter = {
    isDeleted: false,
    snapshot: new Date(),
  };

  return { generalFilterFormFields, dateFilterFormFields, filterQueryStateHandler, initialFilter };
}

export default useHoldingRegisterCommonFilterProps;
